Page homePage
	Good	good
	Field[]	alwaysFields = []
	Field[]	oneByOneFields = []
	int	visibleOneByOneCount = 0
	bool	videoPlaying = false
	ValidationState	validationState = {}
	bool	generalTermsAccepted = false

	show: string id = ""
		html.setTitle "Wohnmobil verkaufen - einfach, sicher und stressfrei" + app.titleSuffix
		if good == null: good = app.createDefaultGood Guest
		loadFields
		validationState.clear

	loadFields
		alwaysFields.clear
		oneByOneFields.clear
		// Filter fields by showOnHomePage
		for app.fields as field
			if !app.user.isGuest and (field.fieldName == "EMail" or field.fieldName == "Telefon"): continue
			if field.showOnHomePage == Always
				alwaysFields.add field
				// Initialize field value
				if good[field.fieldName] == null
					good[field.fieldName] = ""
			else if field.showOnHomePage == OneByOne
				oneByOneFields.add field
				// Initialize field value
				if good[field.fieldName] == null
					good[field.fieldName] = ""

	Field[] getVisibleFields
		Field[] result = []
		for alwaysFields as field
			result.add field
		for visibleOneByOneCount as i
			if i < oneByOneFields.length
				result.add oneByOneFields[i]
		return result
			
	draw
		div display:flex, flexDirection:column, alignItems:center, padding:{bottom:60}, gap:40
			drawTopSection
			drawFormSection
			div app.getText("features") marginTop:32
			div app.getText("faqPage") marginTop:32
			html.closeDetails

	drawTopSection
		column
			div app.getText("homePageTitle")
			div width:100%, display:flex, gap:40, alignItems:flexStart
				div app.getText("homePageIntro")
				div width:640px, height:360px
					let video = div tag:"video", width:640px, height:360px
						borderRadius:20, boxShadow:{offset:{10,10}, blur:30, spread:0, color:#909090}
						display:videoPlaying ? block : none
						data:{src:"intro640x360.mp4", controls:"true", loop:"true"}
					img VideoThumbnail, width:640px, height:360px
						borderRadius:20, boxShadow:{offset:{10,10}, blur:30, spread:0, color:#909090}
						cursor:pointer, display:videoPlaying ? none : block
						onClick:videoPlaying = true; refresh; video.play()

	drawFormSection
		app.box
			column alignItems:center
				div width:400px
					display:flex, flexDirection:column, gap:24
					div "Einfach Fahrzeugdaten eingeben (5 Minuten)", fontSize:18, fontWeight:bold, color:#2b3145
					let visibleFields = getVisibleFields
					for visibleFields as field
						form.drawField field, new Reference(container:good, key:field.fieldName), validationState, 
							onInput: value => onFieldInput(i, field.fieldName, value)
							onChange: value => onFieldChanged(i, field.fieldName, value)
					column
						if visibleOneByOneCount >= oneByOneFields.length
							div marginBottom:16px
								form.toggle model:generalTermsAccepted, label:app.getText("generalTerms"), required:true, validationState
						app.button text:app.getText("callToAction"), onClick:onSubmit

	onFieldInput: int fieldIndex, string fieldName, dynamic value
		print "Field input:", fieldName, "Value:", value
		if fieldIndex >= alwaysFields.length+visibleOneByOneCount-1 and visibleOneByOneCount < oneByOneFields.length
			visibleOneByOneCount++
			if oneByOneFields[visibleOneByOneCount-1].fieldName == "readyForPickupTime"
				visibleOneByOneCount++
			refresh

	onFieldChanged: int fieldIndex, string fieldName, dynamic value
		print "Field changed:", fieldName, "Value:", value
		if !good.id: await app.goods.add good
		await app.goods.updateField good, fieldName, value

	onSubmit
		if validationState.checkForErrorsOrEmptyFields: return
		if !good.id: await app.goods.add good
		app.user.email = good.EMail
		await backend.users.update app.user, {phoneNumber:good.Telefon, generalTermsAccepted}
		if app.user.isGuest: app.navigateTo loginPage
		else                 app.navigateTo editPage, good.id
